import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../api/axios';

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/register', form);
      alert('User registered! Please login.');
      navigate('/login');
    } catch (error) {
      alert('Registration failed: ' + (error.response?.data?.error || error.message));
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Register</h1>
        <form className="auth-form" onSubmit={handleSubmit}>
          <input placeholder="Username" onChange={e => setForm({...form, username: e.target.value})} />
          <input placeholder="Email" onChange={e => setForm({...form, email: e.target.value})} />
          <input type="password" placeholder="Password" onChange={e => setForm({...form, password: e.target.value})} />
          <button type="submit">Register</button>
        </form>
        <div className="extra-links">
          <Link to="/login">Already have an account? Login</Link>
        </div>
      </div>
    </div>
  );
}